import React from 'react';

const ValueAddition = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <p>
          We meet market requirements by converting the primary metals produced into value added products such as
          sheets, rods, bars, rolled products, etc. at our zinc, aluminium and copper businesses.
        </p>
      </div>
    </div>
  );
};

export default ValueAddition;
